// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Found_wrapper__2EK2r","search":"Found_search__1yYys","suggestions":"Found_suggestions__AvGkg","suggestionItem":"Found_suggestionItem__1xBhX"};